module.exports = __webpack_public_path__ + "static/face-effects-for-web-34ab3c29d3a8a4be74bbb9eaac28de97.jpg";